import React from "react";
import { Switch } from "react-router-dom";
import { connect } from "react-redux";
import PrivateRoute from "components/common/PrivateRoute";
import StoresList from "components/menu/master-files/stores/list";

const StoresRouter = props => (
    <div className="px-5">
        <Switch>
            <PrivateRoute
                exact
                path={`${props.match.url}/`}
                component={StoresList}
            />
        </Switch>
    </div>
);

export default connect()(StoresRouter);
